import { Steps as ASteps } from '@ark-ui/solid/steps';
import type { ComponentProps, ParentProps } from 'solid-js';

export function Steps(props: ComponentProps<typeof ASteps.Root>) {
	return <ASteps.Root {...props} />;
}

Steps.List = function StepsList(props: ComponentProps<typeof ASteps.List>) {
	return <ASteps.List class="flex items-center gap-2 md:gap-4" {...props} />;
};

Steps.Item = function StepsItem(props: ParentProps<{ index: number; number: string; disabled?: boolean }>) {
	return (
		<ASteps.Item
			index={props.index}
			class="flex shrink grow items-center gap-2 last-of-type:grow-0 last-of-type:*:data-[part=separator]:hidden md:gap-4"
		>
			<ASteps.Trigger
				class="group flex shrink-0 grow-0 cursor-pointer items-center gap-2 font-bold"
				aria-disabled={props['disabled']}
			>
				<ASteps.Indicator class="grid aspect-square size-10 shrink-0 grow-0 place-items-center rounded-full border border-zinc-300 transition-all group-hover:-translate-y-0.5 group-hover:border-yellow-400 group-active:translate-y-0.5 group-active:bg-yellow-500/20 data-complete:border-yellow-200 data-complete:bg-yellow-500/20 data-current:border-yellow-400 data-incomplete:group-hover:translate-y-0 data-incomplete:group-active:translate-y-0 motion-safe:group-aria-disabled:group-active:animate-shake dark:border-zinc-700 dark:group-hover:border-yellow-600 dark:data-complete:border-yellow-800">
					{props.number}
				</ASteps.Indicator>
				<div class="font-medium">{props.children}</div>
			</ASteps.Trigger>
			<ASteps.Separator class="min-w-0 shrink grow border-t border-zinc-300 dark:border-zinc-700" />
		</ASteps.Item>
	);
};

Steps.Content = function StepsContent(props: ComponentProps<typeof ASteps.Content>) {
	return <ASteps.Content {...props} />;
};

export { useStepsContext, useStepsItemContext } from '@ark-ui/solid/steps';
